(() => {
  if (customElements.get('main-product')) {
    return;
  }

  class MainProduct extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onChangeHandler.bind(this));
      this.addEventListener('click', this.onClickHandler.bind(this));
    }

    connectedCallback() {
      this.initReadMore();
    }

    onClickHandler(event) {
      const toggle = event.target.closest('[data-read-more-toggle]');
      if (!toggle) return;

      const description = toggle.closest('[data-read-more]');
      const content = description.querySelector('[data-read-more-content]');
      const isExpanded = description.classList.toggle('is-expanded');

      if (isExpanded) {
        content.innerHTML = content.dataset.fullHtml;
        toggle.textContent = 'Read less';
      } else {
        this.collapseReadMore(description);
      }
    }

    onChangeHandler(event) {
      if (!event.target.hasAttribute('data-trigger-option')) return

      const selectedOptionValues = Array.from(this.querySelectorAll('fieldset select, fieldset input:checked')).map(element =>
        element.tagName === 'SELECT'
        ? element.options[element.selectedIndex].dataset.optionValueId
        : element.dataset.optionValueId
      );

      fetch(`${this.dataset.url}?section_id=${this.dataset.id}&option_values=${selectedOptionValues}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const focusedElement = document.activeElement;
        document.querySelector('main-product').innerHTML = html.querySelector('main-product').innerHTML

        if(window.location.pathname.includes('product')) {
          window.history.replaceState(null, '', html.querySelector('main-product').dataset.variantUrl);
        }

        this.slideToActiveMedia(html.querySelector('select option[selected], fieldset input:checked').dataset.mediaId)
        this.initReadMore();
        document.getElementById(focusedElement.id).focus();
      })
    }

    initReadMore() {
      this.querySelectorAll('[data-read-more]').forEach((description) => {
        const content = description.querySelector('[data-read-more-content]');
        const toggle = description.querySelector('[data-read-more-toggle]');

        if (!content || !toggle) return;

        content.dataset.fullHtml = content.dataset.fullHtml || content.innerHTML;
        content.dataset.fullText = content.dataset.fullText || content.textContent.trim();

        content.innerHTML = content.dataset.fullHtml;
        description.classList.remove('is-expanded');
        this.collapseReadMore(description);
      });
    }

    collapseReadMore(description) {
      const content = description.querySelector('[data-read-more-content]');
      const toggle = description.querySelector('[data-read-more-toggle]');
      const fullText = content.dataset.fullText;

      content.textContent = fullText;
      toggle.textContent = 'Read more';
      toggle.hidden = true;

      const computedStyle = window.getComputedStyle(description);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const maxHeight = lineHeight * 7;

      if (description.scrollHeight <= maxHeight) return;

      toggle.hidden = false;

      let min = 0;
      let max = fullText.length;
      let best = '';

      while (min <= max) {
        const middle = Math.floor((min + max) / 2);
        const text = fullText.slice(0, middle).trim().replace(/\s+\S*$/, '');

        content.textContent = `${text}...`;

        if (description.scrollHeight <= maxHeight) {
          best = text;
          min = middle + 1;
        } else {
          max = middle - 1;
        }
      }

      content.textContent = `${best}...`;
    }

    slideToActiveMedia(id) {
      document.querySelector('product-media-slideshow').setActive(id);
    }
  }

  customElements.define('main-product', MainProduct);
})();
